const InsuranceCategory = {
  health: 1,
  life: 2,
  car: 23,
  bike: 21,
  gcv: 11,
  pcv: 13,
  miscCV: 17,
  trailer: 19,
  pet: 3,
};

Object.freeze(InsuranceCategory); // Prevent modification

export default InsuranceCategory;
